import React from "react";

const AllDatesCheckbox = ({ allDates, allDatesEnabled, onToggleAllDates }) => {
  return (
    <span className="allDates">
      <input
        type="checkbox"
        id="allDates"
        checked={allDates}
        disabled={!allDatesEnabled}
        onChange={onToggleAllDates}
      />
      <label htmlFor="allDates">All Dates</label>
    </span>
  );
};

export default AllDatesCheckbox;
